var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    [
      _vm.splash
        ? _c(
            "v-content",
            { staticStyle: { "background-color": "gray" } },
            [
              _c(
                "v-container",
                { staticClass: "fill-height", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "4" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mx-auto elevation-12" },
                            [
                              _c(
                                "v-toolbar",
                                {
                                  attrs: {
                                    color: "blue-grey lighten-2",
                                    flat: "",
                                  },
                                },
                                [
                                  _c("v-toolbar-title", [
                                    _vm._v("Caricamento Filolog..."),
                                  ]),
                                ],
                                1
                              ),
                              _c("v-card-text", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-center",
                                    staticStyle: { margin: "10px" },
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        size: 100,
                                        width: 10,
                                        color: "blue-grey darken-2",
                                        indeterminate: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("p", [
                                  _vm._v(
                                    "Ancora un attimo... Fra pochi istanti potrai iniziare."
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.noNetwork
        ? _c(
            "div",
            {
              staticClass: "text-xs-center",
              staticStyle: { "padding-top": "100px" },
            },
            [
              _c("div", [
                _c("h2", [
                  _vm._v("NETWORK OR "),
                  _c("br"),
                  _vm._v(" UNKNOWN ERROR"),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.splash
        ? [
            _vm.user
              ? _c(
                  "v-navigation-drawer",
                  {
                    attrs: {
                      persistent: "",
                      "enable-resize-watcher": "",
                      fixed: "",
                      app: "",
                    },
                    model: {
                      value: _vm.drawer,
                      callback: function ($$v) {
                        _vm.drawer = $$v
                      },
                      expression: "drawer",
                    },
                  },
                  [
                    _c("InfoUtente"),
                    _c(
                      "v-list",
                      { attrs: { dense: "", nav: "" } },
                      _vm._l(_vm.items, function (item, i) {
                        return _c(
                          "v-list-item",
                          { key: i, attrs: { to: item.route, link: "" } },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", [
                                  _vm._v("mdi-" + _vm._s(item.icon)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  { attrs: { "data-test": item.title } },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c("v-divider"),
                    _c(
                      "v-list",
                      { attrs: { dense: "", nav: "" } },
                      [
                        _c(
                          "v-list-item",
                          { on: { click: _vm.logout } },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-logout")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [_c("v-list-item-title", [_vm._v("Esci")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-list-item",
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-switch", {
                                  attrs: { label: "Dark Theme" },
                                  model: {
                                    value: _vm.dark,
                                    callback: function ($$v) {
                                      _vm.dark = $$v
                                    },
                                    expression: "dark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.print
              ? _c(
                  "v-app-bar",
                  { attrs: { app: "", color: "grey lighten-5" } },
                  [
                    _vm.user
                      ? _c("v-app-bar-nav-icon", {
                          attrs: { "data-test": "nav-icon" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.drawer = !_vm.drawer
                            },
                          },
                        })
                      : _vm._e(),
                    _c("v-toolbar-title", [
                      _vm._v(_vm._s(_vm.titolo) + " "),
                      _vm.sottotitolo
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "18px",
                                "font-style": "italic",
                                "padding-right": "10px",
                              },
                            },
                            [_vm._v(" - " + _vm._s(_vm.sottotitolo))]
                          )
                        : _vm._e(),
                    ]),
                    _c("v-progress-linear", {
                      attrs: {
                        "data-test": "progress-bar",
                        active: _vm.loading,
                        indeterminate: _vm.loading,
                        absolute: "",
                        bottom: "",
                        color: "brown darken-1",
                      },
                    }),
                    _c("v-spacer"),
                    _c("router-view", { attrs: { name: "global-commands" } }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-content",
              [
                _c("router-view"),
                _c(
                  "v-navigation-drawer",
                  {
                    attrs: {
                      fixed: "",
                      temporary: "",
                      right: "",
                      width: "400",
                    },
                    model: {
                      value: _vm.opzioniVisibili,
                      callback: function ($$v) {
                        _vm.opzioniVisibili = $$v
                      },
                      expression: "opzioniVisibili",
                    },
                  },
                  [_c("router-view", { attrs: { name: "options-content" } })],
                  1
                ),
                _c(
                  "v-navigation-drawer",
                  {
                    attrs: {
                      fixed: "",
                      temporary: "",
                      right: "",
                      width: "400",
                    },
                    model: {
                      value: _vm.azioniVisibili,
                      callback: function ($$v) {
                        _vm.azioniVisibili = $$v
                      },
                      expression: "azioniVisibili",
                    },
                  },
                  [_c("router-view", { attrs: { name: "actions-content" } })],
                  1
                ),
              ],
              1
            ),
            !_vm.print
              ? _c(
                  "v-footer",
                  { attrs: { fixed: true, app: "" } },
                  [
                    _c("span", [
                      _vm._v(
                        "Copyright © " +
                          _vm._s(new Date().getFullYear()) +
                          " K-Digitale"
                      ),
                    ]),
                    _c("v-spacer"),
                    _c("span", [
                      _vm._v("Versione " + _vm._s(_vm.clientVersion)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.errori && _vm.errori.length > 0
        ? _c(
            "v-snackbar",
            {
              attrs: {
                color: "grey lighten-2",
                value: true,
                timeout: 0,
                bottom: "",
                right: "",
                vertical: "",
                "multi-line": "",
              },
            },
            [
              _vm._l(_vm.errori, function (err, index) {
                return _c(
                  "div",
                  {
                    key: index + err.message,
                    staticStyle: { margin: "10px 0 0 0" },
                    style: {
                      color: err.tipo == 0 ? "red" : "green",
                      "font-size": "20px",
                    },
                  },
                  [_vm._v(" " + _vm._s(err.message) + " ")]
                )
              }),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey", text: "" },
                  on: { click: _vm.segnaMessaggiLetti },
                },
                [_vm._v(" Close ")]
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }